import { useGlobalStore, usePersistantStore } from "@/stores/global";
import BaseLogin from "@/shared/views/BaseLogin";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const setAuthenticated = usePersistantStore(
    (state) => state.setAuthenticated
  );
  const setPasswordChangeNecessary = useGlobalStore(s => s.setPasswordChangeNecessary);
  

  const setAuthenticated2 = (s, u, p) => {
    if (p === "Start123") {
      setPasswordChangeNecessary(true);
    }
    setAuthenticated(s, u);
  };

  return (
    <BaseLogin
      setAuthenticatedWithUser={setAuthenticated2}
      //checkAccessRights={(rights) => "TRANSPLAN" in rights}
      image="/login.jpg"
    />
  );
}
